var templateUrl = require('./epxUnitDetail.html');

angular.module('ciApp').component('epxUnitDetail', {
  templateUrl: templateUrl,
  bindings: {
    epxUnit: '<',
    manufacturers: '<',
    sites: '<'
  },
  controller: ['$state', 'EpxUnitService', 'AuthService', '$uibModal', EpxUnitDetailController]
});

function EpxUnitDetailController($state, EpxUnitService, AuthService, uibModal) {
  var ctrl = this;

  ctrl.$onInit = function() {
    ctrl.canDelete = ctrl.epxUnit.id && AuthService.hasPermission('EpxUnit', 'delete');
    ctrl.unitTypes = ['RDS', 'DR14', 'FDS'];
    ctrl.groupType = _.get(ctrl.epxUnit, 'group.type');
    if (
      _.chain(ctrl.epxUnit)
        .get('group.id')
        .isNil()
        .value()
    ) {
      ctrl.epxUnit.group = null;
    }
  };

  ctrl.saveEpxUnit = function() {
    EpxUnitService.save(ctrl.epxUnit).then(() => {
      $state.go('admin.epx-units');
    });
  };

  ctrl.resetEpxUnitForm = function() {
    ctrl.epxUnit = null;
  };

  ctrl.deleteEpxUnit = function() {
    EpxUnitService.delete(ctrl.epxUnit).then(() => {
      $state.go('admin.epx-units');
    });
  };

  ctrl.goToEpxUnits = function() {
    $state.go('admin.epx-units');
  };

  ctrl.confirmDelete = function($event, unit) {
    stopProp($event);
    var modalInstance = uibModal.open({
      animation: true,
      component: 'modalConfirm',
      size: 'small',
      resolve: {
        message: function() {
          return (
            'Are you sure you want to delete epx unit <strong>' +
            unit.name +
            '</strong>? This action cannot be undone.'
          );
        },
        buttonText: function() {
          return 'Delete';
        },
        buttonClass: function() {
          return 'button-danger';
        },
        item: function() {
          return unit;
        }
      }
    });

    modalInstance.result.then(
      function(unit) {
        ctrl.deleteEpxUnit(unit);
      },
      function() {
        //user cancelled, do
      }
    );
  };

  function stopProp($event) {
    $event.stopPropagation();
  }
}



// WEBPACK FOOTER //
// ./app/admin/epx-units/epxUnitDetail.component.js